import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import {
  patchCommerceLink,
  deleteCommerceLink,
} from 'redux/commerce/actions';

import CommonSwapIcon from 'components/common/link-elements/CommonSwapIcon';
import CommerceLinkTitle
  from 'components/dashboard/commerce-content/commerce-link/CommerceLinkTitle';
import CommonLinkActionButton
  from 'components/common/link-elements/CommonLinkActionButton';
import CommonLinkDeleteButton
  from 'components/common/link-elements/CommonLinkDeleteButton';
import CommerceCheckbox
  from 'components/dashboard/commerce-content/form-elements/CommerceCheckbox';

import './CommerceItemHeader.css';

function CommerceItemHeader(props) {
  const {
    item,
    patchCommerceLink,
    deleteCommerceLink,
    setOpenForm,
    openForm,
    setExpandedLinkId,
  } = props;

  return (
    <div className="commerce-item-header__component">
      <div className="swap-block"><CommonSwapIcon /></div>
      <div className="parameters-block">
        <div className="title-block">
          <CommerceLinkTitle
            linkId={item.id}
            title={item.title}
          />
        </div>
        <div className="actions-block">
          <div className="settings">
            <CommonLinkActionButton
              active={openForm}
              onClick={() => {
                setOpenForm(!openForm);
                if (!openForm) {
                  setExpandedLinkId(item.id);
                }
              }}
              type="settings"
              buttonText="Settings"
            />
          </div>
          <div className="delete">
            <CommonLinkDeleteButton
              linkItem={item}
              deleteFunction={deleteCommerceLink}
            />
          </div>
        </div>
        <div className="published-block">
          <CommerceCheckbox
            key={`commerce-is-published-checkbox-key-${item.id}`}
            linkId={item.id}
            initialValue={item.is_published}
            parameter="is_published"
            patchFunction={patchCommerceLink}
            disabled={!item.payment_provider}
          />
        </div>
      </div>
    </div>
  );
}

CommerceItemHeader.propTypes = {
  patchCommerceLink: PropTypes.func.isRequired,
  deleteCommerceLink: PropTypes.func.isRequired,
  setExpandedLinkId: PropTypes.func.isRequired,
  setOpenForm: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
  openForm: PropTypes.bool.isRequired,
};

const mapStateToProps = state => (
  {}
);

export default connect(
  mapStateToProps,
  {
    patchCommerceLink,
    deleteCommerceLink,
  },
)(CommerceItemHeader);
